/*
  Flowkeeper - Pomodoro timer for power users and teams
  Copyright (c) 2023 Constantine Kulak, Geoffrey Espagne

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation; either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/

export const adminUser = 'admin@local.host';

export abstract class AbstractDataItem<ParentType extends AbstractDataItem<any>> {
    public id: string | undefined;
    public parent: ParentType | undefined;
    public createDate: Date | undefined;
    public lastModifiedDate: Date | undefined;

    protected constructor(another?: AbstractDataItem<ParentType>, id?: string, parent?: ParentType, createDate?: Date) {
        if(another) {
            this.id = another.id;
            this.parent = another.parent;
            this.createDate = another.createDate;
            this.lastModifiedDate = another.createDate;
        }
        else {
            this.id = id;
            this.parent = parent;
            this.createDate = createDate;
            this.lastModifiedDate = createDate;
        }    
    }

    public abstract clone(): AbstractDataItem<any>
}
